import { jsx as _jsx } from "react/jsx-runtime";
import './Badge.css';
const Badge = ({ children, type }) => {
    return _jsx("span", { className: `inlineBadge${type ? ` ${type}Background` : ''}`, children: children });
};
export default Badge;
